<template>
  <div class="deposit-new-box">
    <div class="deposit-top-spacer"></div>
    <!-- 固定头部区域 -->
    <div class="deposit-fixed-header">
      <!-- 头部 -->
      <div class="deposit-header">
        <div class="deposit-header-left" @click="handleClose">
          <van-icon name="arrow-left" color="#fff" size="20" />
        </div>
        <div class="deposit-header-title">存款</div>
        <div class="deposit-header-right">
          <img src="/static/newImg/deposit/comm_icon_cz_kf.svg" class="deposit-qh-icon" @click="$emit('close'); $router.push({ path: '/notice', query: { noticeType: '4', from: 'mine' } })" />
          <img src="/static/newImg/deposit/comm_icon_cz_jl.svg" class="deposit-copy-icon" @click="openRecord" />
        </div>
      </div>

      <!-- 余额 -->
      <div class="deposit-balance">
        <div class="deposit-balance-label">支付方式</div>
        <div class="deposit-balance-amount">
          <img src="/static/newImg/mine/CNY.avif" class="deposit-balance-dot" />
          <span class="deposit-balance-num">0.00</span>
          <img src="/static/newImg/index/refresh01.png" class="deposit-balance-qh" />
        </div>
      </div>

      <!-- 存款方式Tab -->
      <div class="deposit-tabs">
        <div class="deposit-tab-item" :class="{ active: activeTab === 0 }" @click="activeTab = 0">
          <img src="/static/newImg/deposit/img_gift_xie.avif" class="deposit-tab-gift-icon" />
          <div class="deposit-tab-row">
            <img src="/static/newImg/deposit/icon_cz_zxcz1.svg" class="deposit-tab-icon" />
            <span>在线存款</span>
          </div>
          <span class="deposit-tab-badge badge-send2">送2%</span>
        </div>
        <!-- 转账存款、数字货币tab暂时注释
        <div class="deposit-tab-item" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
          <img src="/static/newImg/deposit/img_gift_xie.avif" class="deposit-tab-gift-icon" />
          <div class="deposit-tab-row">
            <img src="/static/newImg/deposit/icon_cz_zz.svg" class="deposit-tab-icon" />
            <span>转账存款</span>
          </div>
          <span class="deposit-tab-badge badge-send2">送2%</span>
        </div>
        <div class="deposit-tab-item" :class="{ active: activeTab === 2 }" @click="activeTab = 2">
          <img src="/static/newImg/deposit/img_gift_xie.avif" class="deposit-tab-gift-icon" />
          <div class="deposit-tab-row">
            <img src="/static/newImg/deposit/icon_cz_xnhb.svg" class="deposit-tab-icon" />
            <span>数字货币</span>
          </div>
          <span class="deposit-tab-badge badge-send1">送1%</span>
        </div>
        -->

      </div>
    </div>

    <!-- 可滚动内容区域 -->
    <div class="deposit-scroll-content">

    <!-- 在线存款内容 -->
    <div class="deposit-content" v-if="activeTab === 0">
      <div class="deposit-methods-grid">
        <div class="deposit-method-item" :class="{ active: selectedOnlineMethod === idx }" v-for="(method, idx) in onlineMethods" :key="idx" @click="selectOnlineMethod(idx)" :style="{ display: (idx < 6 || showMore) ? '' : 'none' }">
          <div class="deposit-method-icon-wrap">
            <img :src="method.icon" class="deposit-method-icon" />
          </div>
          <div class="deposit-method-name">{{ method.name }}</div>
          <span class="deposit-method-badge" v-if="method.badge" :class="method.badgeClass">{{ method.badge }}</span>
        </div>
      </div>

      <!-- 收起/展开 -->
      <div class="deposit-toggle" v-if="onlineMethods.length > 6" @click="showMore = !showMore">
        <span>{{ showMore ? '收起' : '展开' }}</span>
        <van-icon :name="showMore ? 'arrow-up' : 'arrow-down'" size="14" color="#DFB372" />
      </div>
      <div class="deposit-empty-tip" v-if="onlineMethods.length === 0">暂无可用的支付通道，请联系客服</div>
    </div>

    <!-- 转账存款、数字货币内容暂时注释
    <div class="deposit-content" v-if="activeTab === 1">
      <div class="deposit-methods-grid">
        <div class="deposit-method-item" :class="{ active: selectedTransferMethod === idx }" v-for="(method, idx) in transferMethods" :key="idx" @click="selectedTransferMethod = idx">
          <div class="deposit-method-icon-wrap">
            <img :src="method.icon" class="deposit-method-icon" />
            <span class="deposit-method-badge" v-if="method.badge" :class="method.badgeClass">{{ method.badge }}</span>
          </div>
          <div class="deposit-method-name">{{ method.name }}</div>
        </div>
      </div>
      <div class="deposit-transfer-accounts">
        <div class="deposit-transfer-account" :class="{ active: selectedTransferAccount === idx }" v-for="(acc, idx) in transferAccounts" :key="idx" @click="selectedTransferAccount = idx">
          <div class="deposit-transfer-account-name">{{ acc.name }}</div>
          <div class="deposit-transfer-account-range">{{ acc.range }}</div>
          <span class="deposit-method-badge badge-send2" v-if="acc.badge">{{ acc.badge }}</span>
        </div>
      </div>
    </div>

    <div class="deposit-content" v-if="activeTab === 2">
      <div class="deposit-methods-grid">
        <div class="deposit-method-item" :class="{ active: selectedCryptoMethod === idx }" v-for="(method, idx) in cryptoMethods" :key="idx" @click="selectedCryptoMethod = idx">
          <div class="deposit-method-icon-wrap">
            <img :src="method.icon" class="deposit-method-icon" />
            <span class="deposit-method-badge" v-if="method.badge" :class="method.badgeClass">{{ method.badge }}</span>
          </div>
          <div class="deposit-method-name">{{ method.name }}</div>
        </div>
      </div>

      <div class="deposit-transfer-accounts" v-if="selectedCryptoMethod === 1">
        <div class="deposit-transfer-account" :class="{ active: selectedCryptoAccount === idx }" v-for="(acc, idx) in cryptoAccounts" :key="idx" @click="selectedCryptoAccount = idx">
          <div class="deposit-transfer-account-name">{{ acc.name }}</div>
          <div class="deposit-transfer-account-range">{{ acc.range }}</div>
          <span class="deposit-method-badge badge-send2" v-if="acc.badge">{{ acc.badge }}</span>
        </div>
      </div>
    </div>
    -->


    <!-- 子钱包选项卡（根据选中的钱包动态显示） -->
    <div class="deposit-no-wallet-row" v-if="activeTab === 0 && subWallets.length > 0">
      <div class="deposit-no-wallet-item" :class="{ active: selectedSubWallet === idx }" v-for="(wallet, idx) in subWallets" :key="idx" @click="selectedSubWallet = idx">
        <span class="deposit-method-badge badge-send2" v-if="wallet.badge">{{ wallet.badge }}</span>
        <span>{{ wallet.name }}</span>
      </div>
    </div>
    
    <!-- 暂时注释掉 -->
    <!-- <div class="deposit-wallet-download" v-if="activeTab === 0">
      <van-icon name="down" size="14" color="#DFB372" />
      <span>Wallet download</span>
    </div> -->

    <!-- 存款金额 -->
    <div class="deposit-amount-section" v-if="noWalletTab === 0 || activeTab !== 0">
      <div class="deposit-amount-title">存款金额</div>
      <div class="deposit-amount-grid">
        <div class="deposit-amount-btn" v-for="(amt, idx) in amountList" :key="idx" :class="{ active: selectedAmount === amt.value }" @click="selectQuickAmount(amt)">
          <div class="deposit-amount-value">{{ amt.value }}</div>
          <div class="deposit-amount-bonus">+{{ amt.bonus }}</div>
        </div>
      </div>

      <div class="deposit-amount-input-row">
        <div class="deposit-amount-input-wrap">
          <span class="deposit-amount-input-prefix">¥</span>
          <input type="text" class="deposit-amount-input" :placeholder="amountPlaceholder" v-model="depositAmount" @input="onAmountInput" />
        </div>
      </div>
      <!-- <div class="deposit-exchange-rate">
        <span>汇率</span>
        <span class="deposit-exchange-rate-num">1:6.7679657895</span>
        <van-icon name="replay" size="14" color="#DFB372" />
      </div> -->

      <!-- 存款优惠 暂时注释掉-->
      <!-- <div class="deposit-discount-section">
        <div class="deposit-discount-header">
          <img src="/static/newImg/deposit/img_gift_liang.avif" class="deposit-discount-icon" />
          <span class="deposit-discount-title">存款优惠</span>
          <div class="deposit-discount-timer">
            <img src="/static/newImg/deposit/img_xianshi.avif" class="deposit-discount-timer-icon" />
            <div class="deposit-discount-timer-left">
              <span class="deposit-discount-timer-badge">限时</span>
            </div>
            <span class="deposit-discount-timer-text">{{ countdownText }}</span>
          </div>
        </div>
        <div class="deposit-discount-divider">—— 已自动参与以下活动 ——</div>
        <div class="deposit-discount-list">
          <div class="deposit-discount-item">
            <img src="/static/newImg/deposit/img_gift_hui.avif" class="deposit-discount-item-icon " />
            <span class="deposit-discount-item-text">赠送 1.50</span>
            <span class="deposit-discount-item-condition">单笔存款 ≥ 100</span>
          </div>
          <div class="deposit-discount-item">
            <img src="/static/newImg/deposit/img_gift_hui.avif" class="deposit-discount-item-icon" />
            <span class="deposit-discount-item-text">赠送 2.50</span>
            <span class="deposit-discount-item-condition">首次存款 ≥ 1000</span>
          </div>
          <div class="deposit-discount-item">
            <span class="deposit-discount-item-badge">再充100即可领取</span>
            <img src="/static/newImg/deposit/img_gift_hui.avif" class="deposit-discount-item-icon" />
            <span class="deposit-discount-item-text">赠送 2.00</span>
            <span class="deposit-discount-item-condition">累计存款 ≥ 100</span>
          </div>
        </div>
        <div class="deposit-discount-expand" @click="showDiscountMore = !showDiscountMore">
          <span>展开</span>
          <van-icon :name="showDiscountMore ? 'arrow-up' : 'arrow-down'" size="14" color="#DFB372" />
        </div>
      </div> -->
      
      <!-- 温馨提示 -->
      <div class="deposit-tip-text">
        <span class="deposit-tip-label">温馨提示</span>：<br/>请仔细核对充值订单，如未及时到账，请联系客服。
      </div>

      <div class="deposit-submit-btn" :class="{ active: canSubmitDeposit }" @click="onSubmitDeposit">立即存款</div>
    </div>

    <!-- 绑定/设置 -->
    <div class="deposit-bind-row" v-if="noWalletTab === 1">
      <div class="deposit-bind-item">
        <div class="deposit-bind-label">已有账号，可登录绑定</div>
        <div class="deposit-bind-btn">立即绑定</div>
      </div>
      <div class="deposit-bind-item">
        <div class="deposit-bind-label">首次使用？只需设置支付密码</div>
        <div class="deposit-bind-btn deposit-bind-btn-gold">立即设置</div>
      </div>
    </div>

    <!-- 底部提示 -->
    <div class="deposit-footer-tip" v-if="noWalletTab === 1">
      用NO钱包：赚积分，抽大奖，最高<span class="deposit-footer-tip-gold">88888.88</span>
    </div>
    </div>

    <!-- 存款记录弹框 -->
    <div class="deposit-record-overlay" v-if="showDepositRecord" @click="showDepositRecord = false">
      <div class="deposit-record-popup" @click.stop>
        <div class="deposit-record-header">存款记录</div>
        <div class="deposit-record-filters">
          <div class="deposit-record-filter" @click="showDateDropdown = !showDateDropdown">
            <span>{{ dateFilterText }}</span>
            <van-icon :name="showDateDropdown ? 'arrow-up' : 'arrow-down'" size="12" />
          </div>
          <div class="deposit-record-filter" @click="showStatusDropdown = !showStatusDropdown">
            <span>{{ statusFilterText }}</span>
            <van-icon :name="showStatusDropdown ? 'arrow-up' : 'arrow-down'" size="12" />
          </div>
        </div>

        <!-- 日期下拉 -->
        <div class="deposit-date-dropdown" v-if="showDateDropdown">
          <div class="deposit-date-options">
            <div class="deposit-date-option" :class="{ active: dateFilter === 'today' }" @click="onDateFilter('today')">今日</div>
            <div class="deposit-date-option" :class="{ active: dateFilter === 'yesterday' }" @click="onDateFilter('yesterday')">昨日</div>
            <div class="deposit-date-option" :class="{ active: dateFilter === 'all' }" @click="onDateFilter('all')">全部</div>
          </div>
          <div class="deposit-date-custom-label">自定义</div>
          <div class="deposit-date-range">
            <div class="deposit-date-range-col">
              <div class="deposit-date-range-title">开始日期</div>
              <div class="deposit-date-picker">
                <div class="deposit-date-picker-col">
                  <div class="deposit-date-picker-item" v-for="y in yearList" :key="y">{{ y }}</div>
                </div>
                <div class="deposit-date-picker-col">
                  <div class="deposit-date-picker-item" v-for="m in monthList" :key="m">{{ String(m).padStart(2, '0') }}</div>
                </div>
                <div class="deposit-date-picker-col">
                  <div class="deposit-date-picker-item" v-for="d in dayList" :key="d">{{ String(d).padStart(2, '0') }}</div>
                </div>
              </div>
              <div class="deposit-date-picker-value">{{ startDateText }}</div>
            </div>
            <div class="deposit-date-range-col">
              <div class="deposit-date-range-title">结束日期</div>
              <div class="deposit-date-picker">
                <div class="deposit-date-picker-col">
                  <div class="deposit-date-picker-item" v-for="y in yearList" :key="y">{{ y }}</div>
                </div>
                <div class="deposit-date-picker-col">
                  <div class="deposit-date-picker-item" v-for="m in monthList" :key="m">{{ String(m).padStart(2, '0') }}</div>
                </div>
                <div class="deposit-date-picker-col">
                  <div class="deposit-date-picker-item" v-for="d in dayList" :key="d">{{ String(d).padStart(2, '0') }}</div>
                </div>
              </div>
              <div class="deposit-date-picker-value">{{ endDateText }}</div>
            </div>
          </div>
          <div class="deposit-date-btns">
            <div class="deposit-date-btn deposit-date-btn-cancel" @click="showDateDropdown = false">取消</div>
            <div class="deposit-date-btn deposit-date-btn-confirm" @click="confirmDate">确认</div>
          </div>
        </div>

        <!-- 状态下拉 -->
        <div class="deposit-status-dropdown" v-if="showStatusDropdown">
          <div class="deposit-status-option" :class="{ active: statusFilter === '' }" @click="onStatusFilter('')">全部状态</div>
          <div class="deposit-status-option" :class="{ active: statusFilter === '1' }" @click="onStatusFilter('1')">等待付款</div>
          <div class="deposit-status-option" :class="{ active: statusFilter === '2' }" @click="onStatusFilter('2')">存款成功</div>
          <div class="deposit-status-option" :class="{ active: statusFilter === '3' }" @click="onStatusFilter('3')">存款失败</div>
        </div>

        <!-- 充值记录列表 -->
        <div class="deposit-record-list" v-if="recordList.length > 0">
          <div class="dr-item" v-for="rec in recordList" :key="rec.id">
            <div class="dr-item-top">
              <span class="dr-way">{{ rec.pay_way_text || '充值' }}</span>
              <span class="dr-state" :class="drStateClass(rec)">{{ rec.state_text }}</span>
            </div>
            <div class="dr-item-mid">
              <span class="dr-amount">{{ Number(rec.amount).toFixed(2) }}</span>
              <span class="dr-yuan">元</span>
            </div>
            <div class="dr-item-bot">
              <span>订单号：{{ rec.out_trade_no }}</span>
            </div>
            <div class="dr-item-time">{{ rec.created_at }}</div>
          </div>
          <div class="dr-loadmore" v-if="recordPage < recordLastPage" @click="loadRecords(false)">加载更多</div>
          <div class="dr-nomore" v-else>没有更多了</div>
        </div>

        <div class="deposit-record-empty" v-else-if="!recordLoading">
          <img src="/static/image/img_none_sj.avif" class="deposit-record-empty-icon" />
          <div class="deposit-record-empty-text">暂无记录</div>
        </div>
        <div class="deposit-record-close" @click="showDepositRecord = false">
          <van-icon name="cross" size="20" color="#fff" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "depositNew",
  data() {
    return {
      activeTab: 0,
      selectedOnlineMethod: 0,
      selectedSubWallet: 0,
      noWalletTab: 0,
      showMore: false,
      selectedAmount: null,
      selectedTransferAccount: 0,
      selectedTransferMethod: 0,
      selectedCryptoMethod: 0,
      selectedCryptoAccount: 0,
      cryptoWalletTab: 0,
      depositAmount: '',
      showDiscountMore: false,
      showDepositRecord: false,
      showDateDropdown: false,
      showStatusDropdown: false,
      dateFilter: 'today',
      statusFilter: '',
      // 充值记录
      recordList: [],
      recordLoading: false,
      recordPage: 1,
      recordLastPage: 1,
      // 网关下单
      submitting: false,
      // 支付完成跳回轮询
      paybackOrder: '',
      pollTimer: null,
      pollCount: 0,
      startDate: [2026, 7, 15],
      endDate: [2026, 7, 15],
      countdownText: '00:00:00',
      // 金额档位改为接口获取（/api/onlineChannels，按通道返回）
      amountList: [],
      // 原写死档位（保留，勿删，接口异常时可临时恢复）
      // amountList_backup: [
      //   { value: 8, bonus: '0.47' },
      //   { value: 10, bonus: '0.59' },
      //   { value: 15, bonus: '1.19' },
      //   { value: 25, bonus: '1.79' },
      //   { value: 100, bonus: '2.10' },
      //   { value: 300, bonus: '3.5' },
      //   { value: 1000, bonus: '10.0' },
      //   { value: 5000, bonus: '15' },
      // ],
      // 支付通道改为接口获取（/api/onlineChannels，后台「在线通道」配置）
      onlineMethods: [],
      // 原写死通道（保留，勿删，接口异常时可临时恢复）
      // onlineMethods_backup: [
      //   { name: 'No钱包', icon: '/static/newImg/deposit/online/pay_01.avif', badge: '推荐使用 送2%', badgeClass: 'badge-send2' },
      //   { name: '钱能钱包', icon: '/static/newImg/deposit/online/pay_02.avif', badge: '送2%', badgeClass: 'badge-send2' },
      //   { name: '波币钱包', icon: '/static/newImg/deposit/online/pay_03.avif', badge: '送2%', badgeClass: 'badge-send2' },
      //   { name: '购宝钱包', icon: '/static/newImg/deposit/online/pay_04.avif', badge: '送2%', badgeClass: 'badge-send2' },
      //   { name: 'K豆钱包', icon: '/static/newImg/deposit/online/pay_05.avif', badge: '送2%', badgeClass: 'badge-send2' },
      //   { name: 'CGPAY钱包', icon: '/static/newImg/deposit/online/pay_06.avif', badge: '送2%', badgeClass: 'badge-send2' },
      //   { name: '数字钱包', icon: '/static/newImg/deposit/online/pay_07.avif', badge: '送1%', badgeClass: 'badge-send1' },
      //   { name: '支付宝小额', icon: '/static/newImg/deposit/online/pay_08.avif', badge: '送2%', badgeClass: 'badge-send2' },
      //   { name: '点卡支付', icon: '/static/newImg/deposit/online/pay_09.avif', badge: '', badgeClass: '' },
      //   { name: '微信', icon: '/static/newImg/deposit/online/pay_10.avif', badge: '', badgeClass: '' },
      //   { name: '数字人民币', icon: '/static/newImg/deposit/online/pay_11.avif', badge: '', badgeClass: '' },
      //   { name: '银联快捷', icon: '/static/newImg/deposit/online/pay_12.avif', badge: '', badgeClass: '' },
      //   { name: 'QQ充值', icon: '/static/newImg/deposit/online/pay_13.avif', badge: '', badgeClass: '' },
      //   { name: 'NO钱包(扫码)', icon: '/static/newImg/deposit/online/pay_01.avif', badge: '送2%', badgeClass: 'badge-send2' },
      //   { name: 'NO钱包(余额)', icon: '/static/newImg/deposit/online/pay_01.avif', badge: '送2%', badgeClass: 'badge-send2' },
      // ],
      transferMethods: [
        { name: '虚拟币', icon: '/static/newImg/deposit/pay/online_01.png' },
      ],
      transferAccounts: [
        { name: 'USDT-TRC-20(**** Xrb4)', range: '8USDT~108890.34', badge: '送2%', badgeClass: 'badge-send2' },
        { name: 'USDT-ERC-20(**** Kp2m)', range: '10USDT~50000.00', badge: '送1%', badgeClass: 'badge-send1' },
        { name: 'BTC(**** 7Hn9)', range: '0.001BTC~5.0000', badge: '', badgeClass: '' },
        { name: 'ETH(**** 3Qw8)', range: '0.01ETH~100.00', badge: '', badgeClass: '' },
      ],
      cryptoMethods: [
        { name: 'NO钱包(USDT)', icon: '/static/newImg/deposit/shuzi/shuzi_01.avif', badge: '送2%', badgeClass: 'badge-send2' },
        { name: '数字货币', icon: '/static/newImg/deposit/shuzi/shuzi_02.avif', badge: '', badgeClass: '' },
      ],
      // 默认钱包子选项卡（前6个在线存款）
      defaultSubWallets: [
        { name: 'No钱包(扫码)', badge: '送2%' },
        { name: 'No钱包(余额)', badge: '送2%' },
      ],
      // 数字钱包的子选项卡
      digitalSubWallets: [
        { name: 'Upay钱包(扫码)', badge: '送2%' },
        { name: '365pay钱包', badge: '' },
        { name: '808钱包', badge: '' },
        { name: '988Pay', badge: '' },
        { name: '红豆钱包', badge: '' },
        { name: 'Upay钱包', badge: '' },
      ],
      cryptoAccounts: [
        { name: 'USDT-TRC', range: '', badge: '送2%', badgeClass: 'badge-send2' },
        { name: 'USDT', range: '', badge: '送1%', badgeClass: 'badge-send1' },
      ],
    };
  },
  computed: {
    subWallets() {
      const currentMethod = this.onlineMethods[this.selectedOnlineMethod];
      if (currentMethod && currentMethod.name === '数字钱包') {
        return this.digitalSubWallets;
      }
      if (currentMethod && currentMethod.name === 'No钱包') {
        return [
          { name: 'No钱包(扫码)', badge: '送2%' },
          { name: 'No钱包(余额)', badge: '送2%' },
        ];
      }
      // 接口配置的真实支付通道无子钱包选项卡
      return [];
    },
    amountPlaceholder() {
      if (!this.amountList.length) return '请输入存款金额';
      const vals = this.amountList.map(a => Number(a.value)).filter(v => !isNaN(v));
      if (!vals.length) return '请输入存款金额';
      const min = Math.min.apply(null, vals);
      const max = Math.max.apply(null, vals);
      return '最低' + min + '~最高' + Number(max).toLocaleString();
    },
    // 有效存款金额（快捷档位或手动输入）> 0 时按钮才可点
    canSubmitDeposit() {
      const amount = parseFloat(String(this.depositAmount).replace(/[^\d.]/g, ''));
      return !isNaN(amount) && amount > 0;
    },
    dateFilterText() {
      const map = { today: '今日', yesterday: '昨日', all: '全部', custom: '自定义' };
      return map[this.dateFilter] || '今日';
    },
    statusFilterText() {
      const map = { '': '全部状态', '1': '等待付款', '2': '存款成功', '3': '存款失败' };
      return map[this.statusFilter] || '全部状态';
    },
    yearList() {
      const now = new Date().getFullYear();
      return [now - 2, now - 1, now, now + 1];
    },
    monthList() {
      return Array.from({ length: 12 }, (_, i) => i + 1);
    },
    dayList() {
      return Array.from({ length: 31 }, (_, i) => i + 1);
    },
    startDateText() {
      return `${this.startDate[0]} ${String(this.startDate[1]).padStart(2, '0')} ${String(this.startDate[2]).padStart(2, '0')}`;
    },
    endDateText() {
      return `${this.endDate[0]} ${String(this.endDate[1]).padStart(2, '0')} ${String(this.endDate[2]).padStart(2, '0')}`;
    },
  },
  mounted() {
    this.updateCountdown();
    this._countdownTimer = setInterval(() => this.updateCountdown(), 1000);
  },
  beforeDestroy() {
    if (this._countdownTimer) clearInterval(this._countdownTimer);
    this.stopPolling();
  },
  methods: {
    // 获取在线支付通道（每次打开弹窗由 App.vue @open 触发）
    getOnlineChannels() {
      this.$apiFun.post('/api/onlineChannels', {}).then(res => {
        if (res.code == 200) {
          const list = Array.isArray(res.data) ? res.data : [];
          this.onlineMethods = list.map(ch => ({
            id: ch.id,
            way_code: ch.way_code,
            name: ch.name,
            icon: ch.icon,
            badge: ch.badge || '',
            bonus_rate: ch.bonus_rate || 0,
            badgeClass: this.mapBadgeClass(ch.badge),
            amountOptions: (ch.amount_options || []).map(o => ({
              value: Number(o.value),
              bonus: o.bonus,
            })),
          }));
          this.selectedOnlineMethod = 0;
          this.selectedSubWallet = 0;
          this.showMore = false;
          this.applyAmountOptions(0);
        } else {
          this.onlineMethods = [];
          this.amountList = [];
        }
      }).catch(() => {
        this.onlineMethods = [];
        this.amountList = [];
      });
    },
    // 根据通道角标文案映射样式
    mapBadgeClass(badge) {
      if (!badge) return '';
      if (badge.indexOf('送2%') > -1) return 'badge-send2';
      if (badge.indexOf('送1%') > -1) return 'badge-send1';
      return '';
    },
    // 切换支付通道：联动该通道自己的金额档位
    selectOnlineMethod(idx) {
      this.selectedOnlineMethod = idx;
      this.selectedSubWallet = 0;
      this.applyAmountOptions(idx);
    },
    applyAmountOptions(idx) {
      const method = this.onlineMethods[idx];
      this.amountList = method && method.amountOptions ? method.amountOptions : [];
      // 默认不预选任何档位、输入框为空，按钮保持灰色
      this.selectedAmount = null;
      this.depositAmount = '';
    },
    // 点击快捷金额档位：高亮并同步到输入框，按钮变金色
    selectQuickAmount(amt) {
      this.selectedAmount = amt.value;
      this.depositAmount = String(amt.value);
    },
    // 手动输入金额：与某快捷档位相同时高亮该档位，否则取消高亮
    onAmountInput() {
      const inputNum = parseFloat(String(this.depositAmount).replace(/[^\d.]/g, ''));
      const matched = this.amountList.find(a => parseFloat(a.value) === inputNum);
      this.selectedAmount = matched ? matched.value : null;
    },
    // 立即存款：调用网关下单，成功跳转收银台
    onSubmitDeposit() {
      if (!this.canSubmitDeposit || this.submitting) return;
      const method = this.onlineMethods[this.selectedOnlineMethod];
      if (!method) {
        this.$toast('请选择支付方式');
        return;
      }
      let amount = parseFloat(String(this.depositAmount).replace(/[^\d.]/g, ''));
      if (isNaN(amount) || amount <= 0) {
        this.$toast('请输入存款金额');
        return;
      }
      // 前端区间校验（与后端一致）
      const vals = (method.amountOptions || []).map(a => Number(a.value)).filter(v => !isNaN(v) && v > 0);
      if (vals.length) {
        const min = Math.min.apply(null, vals);
        const max = Math.max.apply(null, vals);
        if (amount < min || amount > max) {
          this.$toast('存款金额需在 ' + min + '~' + max + ' 之间');
          return;
        }
      }
      this.submitting = true;
      this.$apiFun.post('/api/gatewayPay/create', {
        channel_id: method.id,
        amount: amount,
      }).then(res => {
        this.submitting = false;
        if (res.code == 200 && res.data && res.data.pay_url) {
          // 存订单号（支付完成回跳后用），直接整页跳转网关收银台
          sessionStorage.setItem('gateway_pending_order', res.data.out_trade_no || '');
          window.location.href = res.data.pay_url;
        } else {
          // 后端 returnMsg 返回字段为 message，兼容 msg
          this.$toast(res.message || res.msg || '下单失败，请稍后重试');
        }
      }).catch(() => {
        this.submitting = false;
        this.$toast('下单失败，请稍后重试');
      });
    },
    // 打开存款记录
    openRecord() {
      this.showDepositRecord = true;
      this.loadRecords(true);
    },
    // 切换状态筛选
    onStatusFilter(val) {
      this.statusFilter = val;
      this.showStatusDropdown = false;
      this.loadRecords(true);
    },
    // 记录状态样式
    drStateClass(rec) {
      const s = Number(rec.state);
      if (s === 2) return 'dr-state-success';
      if (s === 3) return 'dr-state-fail';
      return 'dr-state-wait';
    },
    // 拉取充值记录
    loadRecords(reset) {
      if (reset) {
        this.recordPage = 1;
        this.recordLastPage = 1;
        this.recordList = [];
      }
      if (this.recordLoading) return;
      if (!reset && this.recordPage >= this.recordLastPage) return;
      this.recordLoading = true;
      const params = {
        page: reset ? 1 : this.recordPage + 1,
        page_size: 20,
      };
      if (this.dateFilter && this.dateFilter !== 'custom') {
        params.date_type = this.dateFilter;
      } else if (this.dateFilter === 'custom') {
        const fmt = d => `${d[0]}-${String(d[1]).padStart(2, '0')}-${String(d[2]).padStart(2, '0')}`;
        params.start_time = fmt(this.startDate) + ' 00:00:00';
        params.end_time = fmt(this.endDate) + ' 23:59:59';
      }
      if (this.statusFilter !== '') {
        params.state = this.statusFilter;
      }
      this.$apiFun.post('/api/getrechargerecord', params).then(res => {
        this.recordLoading = false;
        if (res.code == 200 && res.data) {
          const list = res.data.list || [];
          this.recordList = reset ? list : this.recordList.concat(list);
          this.recordPage = res.data.current_page || params.page;
          this.recordLastPage = res.data.last_page || 1;
        }
      }).catch(() => {
        this.recordLoading = false;
      });
    },
    // 支付完成跳回：由 App.vue 调用，自动开记录并轮询该订单
    handlePayback(orderNo) {
      if (!orderNo) return;
      this.paybackOrder = String(orderNo);
      this.dateFilter = 'all';
      this.showDepositRecord = true;
      this.loadRecords(true);
      this.startPolling();
    },
    startPolling() {
      this.stopPolling();
      this.pollCount = 0;
      this.pollTimer = setInterval(() => {
        this.pollCount++;
        if (this.pollCount > 40) { // 最多轮询2分钟
          this.stopPolling();
          return;
        }
        this.$apiFun.post('/api/gatewayPay/query', { out_trade_no: this.paybackOrder }).then(res => {
          if (res.code == 200 && res.data) {
            if (Number(res.data.state) === 2) {
              this.stopPolling();
              this.$toast('存款成功，金额已到账');
              this.loadRecords(true);
              this.$emit('refreshUser');
              try { sessionStorage.removeItem('gateway_pending_order'); } catch (e) {}
            } else if (Number(res.data.state) === 3) {
              this.stopPolling();
              this.$toast('存款失败，如已扣款请联系客服');
              this.loadRecords(true);
            }
          }
        }).catch(() => {});
      }, 3000);
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    updateCountdown() {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const diff = midnight - now;
      const h = String(Math.floor(diff / 3600000)).padStart(2, '0');
      const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
      const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
      this.countdownText = `${h}:${m}:${s}`;
    },
    handleClose() {
      this.$emit("close");
    },
    selectMethod(method) {
      this.$emit("select", method);
    },
    refreshRate() {
      // 刷新汇率
    },
    onDateFilter(val) {
      this.dateFilter = val;
      this.showDateDropdown = false;
      this.loadRecords(true);
    },
    confirmDate() {
      this.dateFilter = 'custom';
      this.showDateDropdown = false;
      this.loadRecords(true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/common.css';

.deposit-top-spacer {
  // height: 1rem;
}

.deposit-fixed-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #1a1a1a;
}

.deposit-scroll-content {
  overflow-y: auto;
  flex: 1;
}

.deposit-new-box {
  width: 100%;
  height: calc(100vh - 1rem);
  background: #1a1a1a;
  border-radius: 0.2rem;
  border: 1px solid #333;
  display: flex;
  flex-direction: column;
  color: #fff;
  overflow: hidden;

  .deposit-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.25rem 0.3rem;
    border-bottom: 1px solid #333;

    .deposit-header-left {
      cursor: pointer;
    }

    .deposit-header-title {
      font-size: 0.35rem;
      font-weight: bold;
    }

    .deposit-header-right {
      display: flex;
      align-items: center;
      gap: 0.15rem;

      .deposit-qh-icon {
        width: 0.5rem;
        height: 0.5rem;
        margin-right:0.2rem;
      }

      .deposit-copy-icon {
        width: 0.5rem;
        height: 0.5rem;
        margin-right:0.2rem;
      }
    }
  }

  .deposit-balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.2rem 0.3rem;

    .deposit-balance-label {
      font-size: 0.3rem;
      color: #fff;
    }

    .deposit-balance-amount {
      display: flex;
      align-items: center;
      gap: 0.08rem;

      .deposit-balance-dot {
        width: 0.55rem;
        height: 0.55rem;
      }

      .deposit-balance-num {
        font-size: 0.35rem;
        font-weight: bold;
        color: #DFB372;
      }

      .deposit-balance-qh {
        width: 0.55rem;
        height: 0.55rem;
      }
    }
  }

  .deposit-tabs {
    display: flex;
    padding: 0.15rem 0.3rem;
    gap: 0.1rem;

    .deposit-tab-item {
      flex: 0 0 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.08rem;
      padding: 0.15rem 0.1rem;
      border: none;
      border-bottom: 2px solid transparent;
      font-size: 0.26rem;
      color: #fff;
      cursor: pointer;
      position: relative;

      .deposit-tab-row {
        display: flex;
        align-items: center;
        gap: 0.08rem;
      }

      .deposit-tab-gift-icon {
        width: 0.45rem;
        height: 0.45rem;
      }

      .deposit-tab-icon {
        width: 0.5rem;
        height: 0.5rem;
        color: inherit;
      }

      .deposit-tab-badge {
        font-size: 0.25rem;
        padding: 0.02rem 0.1rem;
        border-radius: 0.05rem;
        position: absolute;
        top: 0.1rem;
        right: 0.3rem;
      }

      &.active {
        border-bottom-color: #DFB372;
        color: #DFB372;
      }
    }
  }

  .deposit-content {
    padding: 0.2rem 0.3rem;

    .deposit-methods-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 0.15rem;

      .deposit-method-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.1rem;
        padding: 0.15rem 0.1rem;
        border: 1px solid #333;
        border-radius: 0.1rem;
        cursor: pointer;
        position: relative;
        margin:0.1rem 0.1rem;
        &.active {
          border-color: #DFB372;
        }

        &:hover {
          border-color: #DFB372;
        }

        .deposit-method-icon-wrap {
          position: relative;

          .deposit-method-icon {
            width: 0.55rem;
            height: 0.55rem;
          }
        }

        .deposit-method-badge {
          position: absolute;
          top: -0.35rem;
          right: 0rem;
          font-size: 0.25rem;
          padding: 0.02rem 0.1rem;
          border-radius: 0.25rem;
          white-space: nowrap;
        }

        .deposit-method-name {
          font-size: 0.3rem;
          color: #fff;
          flex: 1;
          text-align: center;
        }

        .deposit-method-desc {
          font-size: 0.16rem;
          color: #DFB372;
          text-align: center;
          margin-top: 0.03rem;
        }
      }
    }

    .deposit-toggle {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.05rem;
      padding: 0.15rem 0;
      font-size: 0.26rem;
      color: #DFB372;
      cursor: pointer;
    }

    .deposit-empty-tip {
      text-align: center;
      padding: 0.6rem 0;
      font-size: 0.28rem;
      color: #999;
    }

    .deposit-transfer-accounts {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 0.15rem;
      margin-top: 0.15rem;

      .deposit-transfer-account {
        position: relative;
        border: 1px solid #444;
        border-radius: 0.1rem;
        padding: 0.2rem;
        cursor: pointer;

        &.active {
          border-color: #DFB372;
          background: rgba(223, 179, 114, 0.1);
        }

        .deposit-transfer-account-name {
          font-size: 0.28rem;
          color: #fff;
          text-align: center;
        }

        .deposit-transfer-account-range {
          font-size: 0.22rem;
          color: #999;
          margin-top: 0.05rem;
        }

        .deposit-method-badge {
          position: absolute;
          top: -0.2rem;
          right: 0.1rem;
          font-size: 0.18rem;
          padding: 0.02rem 0.08rem;
          border-radius: 0.05rem;
        }
      }
    }
  }

  .deposit-no-wallet-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.15rem;
    padding: 0 0.3rem 0.15rem;

    .deposit-no-wallet-item {
      position: relative;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.1rem;
      padding: 0.2rem 0;
      border: 1px solid #555;
      border-radius: 0.1rem;
      font-size: 0.26rem;
      color: #fff;
      cursor: pointer;

      &.active {
        border-color: #DFB372;
        color: #DFB372;
        background: rgba(223, 179, 114, 0.1);
      }

      .deposit-method-badge {
        position: absolute;
        top: -0.2rem;
        right: -0.05rem;
        font-size: 0.18rem;
        padding: 0.02rem 0.08rem;
        border-radius: 0.05rem;
        white-space: nowrap;
      }
    }
  }

  .deposit-wallet-download {
    display: flex;
    align-items: center;
    gap: 0.08rem;
    padding: 0.15rem 0.3rem;
    font-size: 0.26rem;
    color: #DFB372;
    border-top: 1px solid #333;
  }

  .deposit-amount-section {
    padding: 0.3rem;

    .deposit-amount-title {
      font-size: 0.32rem;
      color: #fff;
      font-weight: bold;
      margin-bottom: 0.2rem;
    }

    .deposit-amount-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 0.15rem;
      margin-bottom: 0.15rem;

      .deposit-amount-btn {
        background: #000;
        border: 1px solid #000;
        border-radius: 0.1rem;
        // padding: 0.15rem 0.1rem;
        text-align: center;
        cursor: pointer;

        &.active {
          border-color: #DFB372;
          background: #000;
        }

        .deposit-amount-value {
          font-size: 0.35rem;
          color: #fff;
          font-weight:600;
          padding:0.1rem 0;
        }

        .deposit-amount-bonus {
          font-size: 0.3rem;
          // margin-top: 0.05rem;
          background: color-mix(in srgb, #ffaa09 15%, transparent);
          color: #ffaa09;
          padding:0.1rem 0;
        }
      }
    }

    .deposit-amount-tip {
      font-size: 0.22rem;
      color: #999;
      text-align: center;
      margin-bottom: 0.2rem;
    }

    .deposit-amount-input-row {
      display: flex;
      gap: 0.15rem;
      align-items: center;

      .deposit-amount-input-wrap {
        flex: 1;
        display: flex;
        align-items: center;
        background: #2a2a2a;
        border: 1px solid #e74c3c;
        border-radius: 0.1rem;
        padding: 0.25rem 0.2rem;

        .deposit-amount-input-prefix {
          font-size: 0.35rem;
          color: #DFB372;
          margin-right: 0.1rem;
        }

        .deposit-amount-input {
          flex: 1;
          background: transparent;
          border: none;
          color: #fff;
          font-size: 0.35rem;
          outline: none;

          &::placeholder {
            color: #666;
          }
        }
      }

      .deposit-amount-refresh {
        width: 0.7rem;
        height: 0.7rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #2a2a2a;
        border: 1px solid #444;
        border-radius: 0.1rem;
        cursor: pointer;
      }
    }

    .deposit-exchange-rate {
      display: flex;
      align-items: center;
      gap: 0.1rem;
      margin-top: 0.15rem;
      font-size: 0.24rem;
      color: #999;

      .deposit-exchange-rate-num {
        color: #fff;
      }
    }

    .deposit-discount-section {
      margin-top: 0.3rem;
      background: #ffaa090f;
      border-radius: 0.1rem;
      padding: 0.2rem;
      border: 1px solid #ffaa093d;

      .deposit-discount-header {
        display: flex;
        align-items: center;
        gap: 0.1rem;
        margin-bottom: 0.15rem;

        .deposit-discount-icon {
          width: 0.5rem;
          height: 0.5rem;
        }

        .deposit-discount-title {
          font-size: 0.35rem;
          color: #fff;
          font-weight: bold;
        }

        .deposit-discount-timer {
          margin-left: auto;
          display: flex;
          align-items: center;
          border-radius: 0.05rem;
          border: 1px solid #ff4d4f;
          position: relative;

          .deposit-discount-timer-icon {
            position: absolute;
            left: -0.3rem;
            top: 50%;
            transform: translateY(-50%);
            width: 0.3rem;
            height: 0.3rem;
          }

          .deposit-discount-timer-left {
            display: flex;
            align-items: center;
            background: #ff4d4f;
            padding: 0.05rem 0.1rem;
            border-radius: 0.05rem 0 0 0.05rem;

            .deposit-discount-timer-badge {
              color: #fff;
              font-size: 0.2rem;
              font-weight: bold;
            }
          }

          .deposit-discount-timer-text {
            font-size: 0.24rem;
            color: #ff4d4f;
            background: #271D1D;
            padding: 0.05rem 0.1rem;
            border-radius: 0 0.05rem 0.05rem 0;
          }
        }
      }

      .deposit-discount-divider {
        font-size: 0.3rem;
        color: #999;
        text-align: center;
        margin-bottom: 0.15rem;
      }

      .deposit-discount-list {
        .deposit-discount-item {
          display: flex;
          align-items: center;
          gap: 0.1rem;
          padding: 0.15rem 0;
          border-bottom: 1px solid #333;
          background: #1a1a1a;
          margin-bottom:0.1rem;
          padding: .16rem .2rem .16rem .18rem;
          height: 0.8rem;
          position: relative;

          &:last-child {
            border-bottom: none;
          }

          .deposit-discount-item-badge {
            position: absolute;
            top: 0.1rem;
            right: 0.25rem;
            background: #ff4d4f;
            color: #fff;
            font-size: 0.2rem;
            padding: 0.02rem 0.08rem;
            border-radius: 0.05rem;
          }

          .deposit-discount-item-icon {
            width: 0.5rem;
            height: 0.5rem;
          }

          .deposit-discount-item-icon-spin {
            transform: rotate(10deg);
          }

          .deposit-discount-item-text {
            font-size: 0.26rem;
            color: #999;
            flex: 1;
          }

          .deposit-discount-item-condition {
            font-size: 0.25rem;
            color: #999;
            margin-right: 1rem;
          }
        }
      }

      .deposit-discount-expand {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.08rem;
        padding-top: 0.15rem;
        font-size: 0.26rem;
        color: #DFB372;
        cursor: pointer;
      }
    }

    .deposit-tip-text {
      font-size: 0.3rem;
      color: #e3e3e3;
      margin-top: 0.2rem;

      .deposit-tip-label {
        font-weight: bold;
      }
    }

    .deposit-submit-btn {
      margin-top: 0.3rem;
      padding: 0.25rem 0;
      text-align: center;
      background: #666;
      border-radius: 0.1rem;
      font-size: 0.32rem;
      color: #fff;
      cursor: not-allowed;

      &.active {
        background: #DFB372;
        color: #1a1a1a;
        cursor: pointer;
      }
    }
  }

  .deposit-bind-row {
    display: flex;
    gap: 0.15rem;
    padding: 0.2rem 0.3rem;

    .deposit-bind-item {
      flex: 1;

      .deposit-bind-label {
        font-size: 0.2rem;
        color: #999;
        text-align: center;
        margin-bottom: 0.1rem;
      }

      .deposit-bind-btn {
        padding: 0.15rem 0;
        text-align: center;
        border: 1px solid #555;
        border-radius: 0.1rem;
        font-size: 0.28rem;
        color: #fff;
        cursor: pointer;

        &.deposit-bind-btn-gold {
          background: #DFB372;
          color: #1a1a1a;
          border-color: #DFB372;
        }
      }
    }
  }

  .deposit-footer-tip {
    text-align: center;
    padding: 0.15rem 0.3rem 0.25rem;
    font-size: 0.24rem;
    color: #999;

    .deposit-footer-tip-gold {
      color: #DFB372;
      font-weight: bold;
    }
  }
}

.badge-send2 {
  background: #ff4444;
  color: #fff;
}

.badge-send1 {
  background: #ff8800;
  color: #fff;
}

.deposit-record-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.deposit-record-popup {
  width: 80%;
  height: 65%;
  background: #1a1a1a;
  border-radius: 0.2rem;
  padding: 0.4rem 0.3rem;
  position: relative;
  display: flex;
  flex-direction: column;
}

.deposit-record-header {
  text-align: center;
  font-size: 0.35rem;
  color: #fff;
  margin-bottom: 0.3rem;
}

.deposit-record-filters {
  display: flex;
  gap: 0.2rem;
  margin-bottom: 0.4rem;
}

.deposit-record-filter {
  display: flex;
  align-items: center;
  gap: 0.1rem;
  padding: 0.1rem 0.2rem;
  border: 1px solid #555;
  border-radius: 0.1rem;
  font-size: 0.26rem;
  color: #fff;
}

.deposit-record-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex: 1;
}

.deposit-record-empty-icon {
  width: 2rem;
  height: 2rem;
  margin-bottom: 0.2rem;
  opacity: 0.5;
}

.deposit-record-empty-text {
  font-size: 0.28rem;
  color: #999;
}

.deposit-record-close {
  position: absolute;
  bottom: -1rem;
  left: 50%;
  transform: translateX(-50%);
  width: 0.5rem;
  height: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #fff;
  border-radius: 50%;
  cursor: pointer;
}

.deposit-date-dropdown {
  background: #222;
  border-radius: 0.15rem;
  padding: 0.3rem;
  margin-bottom: 0.2rem;
}

.deposit-date-options {
  display: flex;
  gap: 0.15rem;
  margin-bottom: 0.2rem;
}

.deposit-date-option {
  flex: 1;
  text-align: center;
  padding: 0.15rem 0;
  border: 1px solid #555;
  border-radius: 0.1rem;
  font-size: 0.28rem;
  color: #fff;
  cursor: pointer;

  &.active {
    border-color: #DFB372;
    color: #DFB372;
  }
}

.deposit-date-custom-label {
  font-size: 0.26rem;
  color: #999;
  margin-bottom: 0.15rem;
}

.deposit-date-range {
  display: flex;
  gap: 0.2rem;
  margin-bottom: 0.2rem;
}

.deposit-date-range-col {
  flex: 1;
}

.deposit-date-range-title {
  text-align: center;
  font-size: 0.26rem;
  color: #999;
  margin-bottom: 0.1rem;
}

.deposit-date-picker {
  display: flex;
  height: 1.5rem;
  overflow: hidden;
  position: relative;
}

.deposit-date-picker-col {
  flex: 1;
  overflow: hidden;
  text-align: center;
}

.deposit-date-picker-item {
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.26rem;
  color: #666;
}

.deposit-date-picker-value {
  text-align: center;
  font-size: 0.28rem;
  color: #fff;
  margin-top: 0.1rem;
}

.deposit-date-btns {
  display: flex;
  gap: 0.2rem;
}

.deposit-date-btn {
  flex: 1;
  text-align: center;
  padding: 0.15rem 0;
  border-radius: 0.1rem;
  font-size: 0.28rem;
  cursor: pointer;
}

.deposit-date-btn-cancel {
  border: 1px solid #DFB372;
  color: #DFB372;
}

.deposit-date-btn-confirm {
  background: #DFB372;
  color: #1a1a1a;
}

.deposit-status-dropdown {
  background: #222;
  border-radius: 0.15rem;
  padding: 0.1rem 0;
  margin-bottom: 0.2rem;
  max-height: 3rem;
  overflow-y: auto;
}

.deposit-status-option {
  padding: 0.2rem 0.3rem;
  font-size: 0.28rem;
  color: #999;
  cursor: pointer;

  &.active {
    color: #DFB372;
  }
}

.deposit-record-list {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.dr-item {
  background: #222;
  border-radius: 0.15rem;
  padding: 0.25rem 0.3rem;
  margin-bottom: 0.2rem;
}

.dr-item-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.15rem;
}

.dr-way {
  font-size: 0.28rem;
  color: #fff;
}

.dr-state {
  font-size: 0.26rem;
}

.dr-state-success {
  color: #4caf50;
}

.dr-state-fail {
  color: #f56c6c;
}

.dr-state-wait {
  color: #DFB372;
}

.dr-item-mid {
  display: flex;
  align-items: baseline;
  margin-bottom: 0.15rem;
}

.dr-amount {
  font-size: 0.4rem;
  font-weight: bold;
  color: #DFB372;
  margin-right: 0.08rem;
}

.dr-yuan {
  font-size: 0.24rem;
  color: #999;
}

.dr-item-bot {
  font-size: 0.24rem;
  color: #999;
  margin-bottom: 0.1rem;
  word-break: break-all;
}

.dr-item-time {
  font-size: 0.22rem;
  color: #666;
}

.dr-loadmore {
  text-align: center;
  padding: 0.2rem 0;
  font-size: 0.26rem;
  color: #DFB372;
  cursor: pointer;
}

.dr-nomore {
  text-align: center;
  padding: 0.2rem 0;
  font-size: 0.24rem;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/libs/depositNew.vue